export default () => ({
  CampaignDetailsList: {
    '&.fix-header .ms-DetailsList-headerWrapper': {
      position: 'sticky',
      top: 0,
      background: '#fff',
      zIndex: 10,
    },
    '&.has-freeze-column': {
      '& .ms-DetailsRow-cellCheck, & .ms-DetailsHeader-cellIsCheck': {
        position: 'sticky',
        zIndex: 3,
        background: '#fff',
        left: 0,
        marginTop: 1,
        height: 'auto',
      },
    },
    '& .ms-DetailsRow-check': {
      opacity: 1,
      '& .ms-Checkbox-checkbox': {
        cursor: 'pointer',
      },
      '& .ms-Checkbox.is-disabled': {
        '& .ms-Checkbox-checkbox': {
          borderColor: 'rgb(50, 49, 48)',
          '&:after': {
            borderColor: 'rgb(0, 120, 212)',
          },
        },
        '&.is-checked .ms-Checkbox-checkbox': {
          borderColor: 'rgb(0, 120, 212)',
          background: 'rgb(0, 120, 212)',
        },
      },
    },
    '& .ms-DetailsHeader': {
      borderTop: '2px solid #81868B',
      borderBottom: '2px solid #81868B',
      paddingTop: 0,
      overflow: 'hidden',
      minWidth: 'initial !important',
      width: '100%',
    },
    '& .ms-DetailsHeader-cell:hover': {
      background: 'transparent',
    },
    '& .ms-DetailsList-contentWrapper': {
      overflow: 'hidden',
      '& > .ms-SelectionZone': {
        fontSize: 0,
      },
    },
    '& .ms-DetailsRow': {
      '&:hover': {
        '& .campaign-details-list-cell-edit': {
          visibility: 'visible',
        },
        '& .freeze-columns-group, & .ms-DetailsRow-cellCheck': {
          background: 'rgb(243, 242, 241)',
        },
      },
      '&.is-selected': {
        '& .freeze-columns-group, & .ms-DetailsRow-cellCheck': {
          background: 'rgb(237, 235, 233)',
        },
        '&:hover': {
          '& .freeze-columns-group, & .ms-DetailsRow-cellCheck': {
            background: 'rgb(225, 223, 221)',
          },
        },
      },
      '& .freeze-columns-group': {
        background: '#fff',
        position: 'sticky',
        zIndex: 3,
        left: 0,
        boxShadow: '-7.2px 0px 7.2px 7.2px rgb(0 0 0 / 13%)',
        clipPath: 'inset(1px -15px 0px 0px)',
        borderTop: '1px solid #fff',
        '&.has-checkbox': {
          left: 48,
        },
        '&.right': {
          left: 'auto',
          right: 0,
          boxShadow: '7.2px 0px 7.2px 7.2px rgb(0 0 0 / 13%)',
          clipPath: 'inset(0px 0px 1px -15px )',
        },
      },
    },
    '& .ms-DetailsHeader-cell, & .ms-DetailsRow-cell': {
      borderRight: '1px solid #EDEBE9',
      height: '100%',
      '&.ms-DetailsRow-cellCheck, &.ms-DetailsHeader-cellIsCheck': {
        borderRight: 'none',
      },
      '&.freeze-column-cell': {
        background: '#fff',
        position: 'sticky',
        zIndex: 5,
        left: 48,
        '&.has-shadow': {
          boxShadow: '-7.2px 0px 7.2px 7.2px rgb(0 0 0 / 13%)',
          clipPath: 'inset(0px -15px 0px 0px)',
        },
        '&.has-left-shadow': {
          boxShadow: '7.2px 0px 7.2px 7.2px rgb(0 0 0 / 13%)',
          clipPath: 'inset(0px 0px 1px -15px)',
        },
      },
      '&:last-child': {
        borderRight: 'none',
      },
      '&.ms-DetailsHeader-cell:nth-last-child(2)': {
        borderRight: 'none',
      },
      '& .campaign-details-list-cell-content, & .campaign-details-list-cell-edit': {
        verticalAlign: 'middle',
        '&.campaign-details-list-cell-content': {
          maxWidth: 'calc(100% - 35px)',
          display: 'inline-block',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        },
        '&.campaign-details-list-cell-edit': {
          visibility: 'hidden',
          marginLeft: 3,
          height: 18,
          '&:hover': {
            background: 'transparent',
          },
        },
      },
    },
    '& .ms-DetailsHeader-cellSizer': {
      cursor: 'col-resize',
      zIndex: 3,
      '&:after': {
        display: 'none',
      },
    },
    '& .segmentation-row .ms-DetailsRow-cellCheck .ms-DetailsRow-check': {
      visibility: 'hidden',
    },
    '.ms-DetailsHeader-cellTitle[role="button"]': {
      cursor: 'pointer',
    },
  },
  scrollBar: {
    height: 17,
    overflowX: 'auto',
    overflowY: 'hidden',
    background: 'transparent',
    '& .scroll-bar-child': {
      height: 17,
    },
    '&.invisible': {
      visibility: 'hidden',
    },
  },
  scrollBarFixed: {
    position: 'fixed',
    bottom: 0,
    height: 17,
    overflowX: 'auto',
    overflowY: 'hidden',
    background: 'transparent',
    '& .scroll-bar-child': {
      height: 17,
    },
    '&.invisible': {
      visibility: 'hidden',
    },
  },
  placeholder: {
    fontSize: 24,
  },
});
